// Fixed-timestep clock. Simulation advances in fixed dt increments regardless of
// real frame time, so replays are deterministic. See research/DECISIONS.md #2.

export type UpdateFn = (dt: number, step: number) => void;

export class FixedClock {
  readonly dt: number;
  step = 0;
  private acc = 0;
  private readonly maxCatchup = 8;

  constructor(hz = 60) {
    this.dt = 1 / hz;
  }

  /** Interactive: feed real elapsed seconds; runs 0..maxCatchup fixed steps. */
  advance(realDeltaSec: number, update: UpdateFn): void {
    this.acc += Math.min(realDeltaSec, this.dt * this.maxCatchup);
    let n = 0;
    while (this.acc >= this.dt && n < this.maxCatchup) {
      update(this.dt, this.step);
      this.acc -= this.dt;
      this.step++;
      n++;
    }
  }

  /** Deterministic: one exact fixed step (used by replay/tests). */
  tick(update: UpdateFn): void {
    update(this.dt, this.step);
    this.step++;
  }

  reset(): void {
    this.step = 0;
    this.acc = 0;
  }
}
